module.exports = __webpack_public_path__ + "img/cozy.b8104bad.webp";